import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Authorization } from '../model/authorization';
import { ReservationSlot } from '../model/reservation-slot';

@Injectable()
export class AuthorizationService {
    constructor( private dataService: DataService) { }

    private readonly  authorizationOverMedicalAppointmentCreateEndPoint: string =
    '/authorization/authorizationOverMedicalAppointmentCreate/';

    private readonly  authorizeEndPoint: string =
    '/authorization/authorize/';

    private readonly  authorizationCancelEndPoint: string =
    '/authorization/authorizationCancel/';

    async authorizationCancel(authorization: Authorization, observations: string): Promise<boolean> {
        const param = {
            Authorization: authorization
            , Observations: observations
        };
        return await this.dataService.post<boolean>(
            this.authorizationCancelEndPoint, param).toPromise();
    }

    async authorizationOverMedicalAppointmentCreate(reservationSlot: ReservationSlot): Promise<Authorization> {
        return await this.dataService.post<Authorization>(
            this.authorizationOverMedicalAppointmentCreateEndPoint, reservationSlot).toPromise();
    }

    async authorize(authorization: Authorization, pass: string, observations: string): Promise<boolean> {
        const param = {
            Authorization: authorization
            , Pass: pass
            , Observations: observations
        };
        return await this.dataService.post<boolean>(
            this.authorizeEndPoint, param).toPromise();
    }
}
